import React from "react";
import ReactDOM from "react-dom/client";
import cn from "classnames";
import Collapse from "championship/src/components/Collapse";
import {createStore, withStore} from "game_play/utils/store";
import {createLocationObserver} from "championship/src/components/LocationHashObserver";
import DatePicker, {renderInputDateStepper} from "championship/src/components/DatePicker";
import EmptyState from "championship/src/components/EmptyState/emptyState";
import Tournaments, {isStandaloneTournament, toRequestDate} from "../model/tournaments";
import {GameRowPlayer} from "./utils";
import DotLive from "championship/src/components/DotLive";
import {ReactComponent as Medal} from 'championship/static/championship/icon/phosphor/medal.svg'
import IndexPageAD from "championship/src/components/Advertising/IndexPage";
import '../static/tournament/style/tournaments.css'

const LocationObserver = createLocationObserver({
  hashKey: 'tournament', defaultValue: 'all'
})


const formattedDate = new Intl.DateTimeFormat('ru-RU', {
  day: '2-digit', month: '2-digit', year: 'numeric'
});

class TableTournaments extends React.Component {
  state = {
    activeTab: LocationObserver.getValue(),
    completed: LocationObserver.getValue() === 'past' ? true : null,
    date: null,
    opened: {}
  }

  unsubscribeSocket = null

  isStandalone = (tournament) => isStandaloneTournament(tournament)

  // Рисовать ли строку БЕЗ ссылки на лигу. Раньше это решал один `isStandalone`, и предполагалось,
  // что «не standalone» ⇒ лига есть. После переезда на Org-primary турнир может жить прямо под
  // организацией, БЕЗ лиги (`/org/<slug>/tournaments/<id>/`) — и тогда `tournament.league` равен
  // null, а `league.absolute_url` роняет весь список на главной (TypeError в render, страница
  // пустая). Предикат разводит два разных вопроса: «это одиночная игра?» и «есть ли куда вести
  // ссылку». Логотип уже читался опционально (`tournament?.league?.image`) — тут догоняем остальное.
  withoutLeagueLink = (tournament) => (
    this.isStandalone(tournament) || !tournament?.league?.absolute_url
  )

  isSpriteImage = (url) => typeof url === 'string' && url.includes('.svg#')

  renderLeagueLogo = (tournament) => {
    const image = tournament?.league?.image
    const alt = tournament?.league?.name || ''
    if (this.isSpriteImage(image)) {
      const [spritePath, spriteId] = image.split('#')
      const spriteHref = spriteId ? `${spritePath}#${spriteId}` : image
      return (
        <div className="tournament-row__logo-sprite" aria-label={alt}>
          <svg>
            <use href={spriteHref} xlinkHref={spriteHref}></use>
          </svg>
        </div>
      )
    }
    // Нет картинки — НЕ рендерим `<img>` вовсе. С пустым `src` браузер рисует иконку «битое
    // изображение» вместо логотипа: так выглядел турнир под организацией без логотипа. Пустая
    // рамка честнее сломанной картинки, и это ровно тот случай, когда «ничего» — правильный ответ.
    if (!image) return null
    return <img src={image} alt={alt}/>
  }

  onLocationValueChange = (value) => {
    this.setState({
      activeTab: value, completed: value === 'past' ? true : null, date: null
    })
  }

  handlerRowClick = (tournament) => (e) => {
    if (e.target.closest('[data-inside-link]')) return;
    if (e.target.closest('[data-inside-button]')) {
      e.preventDefault();
      return;
    }
    if (!tournament.games.length) return;

    e.preventDefault()

    this.setState((state) => {
      state.opened[tournament.id] = !state.opened[tournament.id]
      return state
    })
  }

  handlerShiftDay = (shift) => () => {
    if (!this.state.date) this.setState({date: new Date()})
    const newDate = new Date(this.state.date);
    newDate.setDate(this.state.date.getDate() + shift);
    this.setState({date: newDate})
  }

  filterTournament(tournaments, filter) {
    return tournaments.filter(tournament => {
      if (filter === 'past') {
        return tournament.completed
      }
      if (filter === 'live') {
        return !tournament.completed && this.props.Tournaments.isLive(tournament)
      }
      return true
    })
  }

  fetchTournaments(force) {
    const {Tournaments} = this.props
    const requestDate = toRequestDate(this.state.date)

    Tournaments.fetch({
      date: requestDate, completed: this.state.completed
    }, force).then((tournaments) => {
      // this.setState((state) => {
      //   tournaments.forEach((tournament) => {
      //     if (!(tournament.id in state)) {
      //       state.opened[tournament.id] = Tournaments.isLive(tournament)
      //     }
      //   })
      //   return state
      // })
    })
    if (this.unsubscribeSocket) this.unsubscribeSocket()
    this.unsubscribeSocket = Tournaments.subscribe({date: requestDate})
  }

  componentDidMount() {
    this.fetchTournaments(true)
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state.date !== prevState.date || this.state.completed !== prevState.completed) {
      this.fetchTournaments(true)
    }
  }

  componentWillUnmount() {
    if (this.unsubscribeSocket) {
      this.unsubscribeSocket()
    }
  }

  render() {
    const {Tournaments} = this.props
    const tournaments = Tournaments.get('tournaments')
    const {opened, date} = this.state
    const activeTab = this.state.activeTab

    const tournamentsFiltered = this.filterTournament(tournaments, activeTab)

    return (
      <IndexPageAD>
        <div className="container-spacer">
          <LocationObserver.Component onValueChange={this.onLocationValueChange}/>
          <div className='tournaments-naviagation'>
            <div className="base-tabs">
              <a href="#tournament=all" className={cn("base-tab", {
                '-active': activeTab === 'all'
              })}>{gettext('Все')}</a>
              <a href="#tournament=live" className={cn("base-tab", {
                '-active': activeTab === 'live'
              })}>{gettext('LIVE')}</a>
              <a href="#tournament=past" className={cn("base-tab", {
                '-active': activeTab === 'past'
              })}>{gettext('Завершённые')}</a>
            </div>
            <DatePicker
              className='tournament-date-picker'
              value={date}
              onChange={(date) => {
                this.setState({date})
              }}
              renderInput={renderInputDateStepper}
            />
          </div>
          <div className='tournaments-table-body'>
            {Tournaments.get('status') === 'loading' ? (<div className="loader-ui">
              <div/>
              <div/>
              <div/>
              <div/>
              <div/>
            </div>) : !tournamentsFiltered.length && (
              <EmptyState prev={this.handlerShiftDay(-1)} next={this.handlerShiftDay(1)}/>)}
            {tournamentsFiltered.map(tournament => (<React.Fragment key={tournament.id}>
              <a href={tournament.absolute_url}
                 className='tournament-row' onClick={this.handlerRowClick(tournament)}>
                <div className="tournament-row__logo">
                  {this.withoutLeagueLink(tournament) ? (
                    this.renderLeagueLogo(tournament)
                  ) : (
                    <a href={tournament.league.absolute_url} data-inside-link>
                      {this.renderLeagueLogo(tournament)}
                    </a>
                  )}
                </div>
                <div className='tournament-row__body'>
                  <div className="tournament-row__name">
                    {this.withoutLeagueLink(tournament) ? (
                      tournament.title
                    ) : (
                      <a href={tournament.league.absolute_url} data-inside-link>
                        {tournament.league.name}
                      </a>
                    )}
                  </div>
                  <div className="tournament-row__desc">
                    {this.isStandalone(tournament) ? (
                      <>
                        <div className="tournament-row__desc-block">
                          <div className="tournament-row__desc-name">{gettext('Формат игры:')}</div>
                          <div className="tournament-row__desc-value">
                            {tournament.type_game_display || tournament.type_game}
                          </div>
                        </div>
                        <div className="tournament-row__desc-block">
                          <div className="tournament-row__name-value">{tournament.title}</div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="tournament-row__desc-block">
                          <div className="tournament-row__desc-name">{gettext('Формат игры:')}</div>
                          <div className="tournament-row__desc-value">{tournament.type_game_display}</div>
                        </div>
                        {tournament.completed && tournament.winner ? (<div className="tournament-row__desc-block">
                          <div className="tournament-row__desc-name icon -s">
                            <Medal/>
                          </div>
                          <div className="tournament-row__desc-value">
                            <a href={URLS.player_view.replace('0', tournament.winner.id)} data-inside-link>
                              {tournament.winner.short_name}
                            </a>
                          </div>
                        </div>) : (<div className="tournament-row__desc-block">
                          <div className="tournament-row__name-value">{tournament.title}</div>
                        </div>)}
                      </>
                    )}
                  </div>
                </div>
                <div className="tournament-row__extra">
                  <div className='tournament-row__info'>
                    <div className={cn('tournament-row__info-status', `-${Tournaments.getStatus(tournament)}`)}>
                      {Tournaments.getStatusText(tournament)}
                    </div>
                    <div className="tournament-row__info-date">
                      {formattedDate.format(new Date(tournament.date))}
                    </div>
                  </div>
                  <div className={cn("tournament-row__collapse", {
                    '-hide': !tournament.games.length, '-open': opened[tournament.id]
                  })}>
                    <div className="svg-icon">
                      <svg>
                        <use href={`${window.static_urls.svg_sprites_common}#box_arrow_left`}></use>
                      </svg>
                    </div>
                  </div>
                </div>
              </a>
              <Collapse isOpen={opened[tournament.id]}>
                <div className="tournament-games">
                  {tournament.games.map(game => (
                    <a href={URLS.game_view.replace('0', game.id)} key={game.id} className='tournament-games-row'>
                      <GameRowPlayer game={game}/>
                      <div className='tournament-games-row__info'>
                        {game.stage_display}
                      </div>
                      <div className='tournament-games-row__score'>
                        {game.score_1} : {game.score_2}
                        {game.live && (
                          <DotLive className='tournament-games-row__live'/>
                        )}
                      </div>
                    </a>))}
                  {!this.isStandalone(tournament) && (
                    <a href={tournament.absolute_url}
                       className='tournament-games__link'>{gettext('Смотреть турнир')}</a>
                  )}
                </div>
              </Collapse>
            </React.Fragment>))}
          </div>
        </div>
      </IndexPageAD>
    )
  }
}

const TableTournamentsWithStore = createStore(withStore(TableTournaments), {
  Tournaments
}, {
  tournaments: window.INIT_DATA || []
})

const root = ReactDOM.createRoot(document.getElementById('table-tournaments'));
root.render(<TableTournamentsWithStore/>);
